import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { show as showEndTenancyModal } from '@/features/EndTenancy/end-tenancy-modal'
import { fontWeights } from '@/styles'

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  text-align: left;
  font-weight: ${fontWeights.medium};

  ${({ customStyle }) => customStyle}
`

const EndTenancyButton = ({
  listingId,
  tenants,
  stateMachine,
  endTenancyRequestData,
  customStyle
}) => {
  const { t } = useTranslation()
  const isPastTenant = stateMachine === 'history'
  const wasEndedManually = endTenancyRequestData?.state_machine === 'done'

  const endTenancyActionText = () => {
    const incompleteText = t('l.tenants.view.end_this_tenancy.button', 'End this tenancy')
    const activeText = t('l.tenants.view.end_tenancy_requested.button', 'End tenancy requested')
    const completeText = t('l.tenants.view.end_tenancy_completed.button', 'End tenancy completed')

    if (
      endTenancyRequestData?.end_response === 'declined' ||
      endTenancyRequestData?.end_response === 'support_requested'
    )
      return incompleteText
    const states = { done: completeText, active: activeText }
    return states[endTenancyRequestData?.state_machine] || incompleteText
  }

  // do not display for past contracts that were not ended manually
  if (isPastTenant && !wasEndedManually) return null

  return (
    <Button onClick={() => showEndTenancyModal({ listingId })} customStyle={customStyle}>
      {endTenancyActionText()}
    </Button>
  )
}

export default styled(EndTenancyButton)``
